import { useLocation } from 'react-router';

import { getPageViewId } from '~/utils/navigationContext';

// Subscribes to the router purely to re-render on a navigation: the view id lives in session
// storage, which React cannot observe, so without this a caller that reads nothing else from
// the location would keep returning the id of the view it first rendered under.
export default function usePageViewId(): string | undefined {
  useLocation();

  return getPageViewId();
}
